import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'

export default createUseStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 434,
    margin: '0 auto',
    textAlign: 'center',
    height: 'calc(100% - 170px)',
    [forPhoneOnly]: {
      padding: 24,
      justifyContent: 'flex-start',
    },
  },
  animationContainer: {
    display: 'flex',
    justifyContent: 'center',
    [forPhoneOnly]: {
      margin: '12px 0 48px 0',
    },
  },
  animation: {
    width: 254,
    height: 'auto',
    [forPhoneOnly]: {
      width: 191,
    },
  },
  text: {
    ...typography['Lato H5'],
    [forPhoneOnly]: {
      ...typography['Lato Body 1'],
    },
  },
})
